import * as Dialog from "@radix-ui/react-dialog";
import { ReactNode } from "react";
import { Button } from "./Button";
import { cn } from "../../utils/cn";

interface ModalProps {
  title: string;
  description?: string;
  trigger?: ReactNode;
  open: boolean;
  onOpenChange: (value: boolean) => void;
  children: ReactNode;
}

export const Modal = ({ title, description, trigger, open, onOpenChange, children }: ModalProps) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    {trigger && <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>}
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" />
      <Dialog.Content className="fixed z-50 w-full max-w-lg rounded-xl border border-slate-800 bg-slate-950 p-6 shadow-2xl focus:outline-none left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="space-y-2">
          <Dialog.Title className="text-lg font-semibold text-slate-100">{title}</Dialog.Title>
          {description ? (
            <Dialog.Description className="text-sm text-slate-400">
              {description}
            </Dialog.Description>
          ) : null}
        </div>
        <div className="mt-4">{children}</div>
        <Dialog.Close asChild>
          <Button variant="ghost" className={cn("absolute right-4 top-4 text-slate-400")} size="icon" aria-label="Close dialog">
            X
          </Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
